import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Waypoint from 'react-waypoint';

import EBPropTypes from 'js-utils/prop-types';
import Carousel from 'eventbrite_design_system/carousel/Carousel';

import {
    BUCKET_CONFIG_PROPTYPE,
    ORGANIZER_ARTICLE_BUCKET_PROPTYPE,
} from '../constants/propTypes';
import {
    GA_PREVIOUS_SLIDE_ACTION,
    GA_NEXT_SLIDE_ACTION,
} from '../constants/analytics';

import { storeLastVisitedCard } from '../utils/localStorage';

import LoadingCards, {
    ORGANIZER_ARTICLE_TYPE,
} from './ConsumerEventCard/LoadingCards';
import OrganizerArticleCard from './OrganizerArticleCard/OrganizerArticleCard';

import './CarouselOverrides.scss';
import './OrganizerArticleBucket.scss';

const TRANSITION_DURATION = 300;

const getOrganizerArticleKey = ({ bucketKey, organizerArticles, index }) => {
    let articleKey = `${bucketKey}-organizerArticleCard`;

    if (organizerArticles && organizerArticles.length) {
        const organizerArticleId = organizerArticles[index]
            ? organizerArticles[index].id
            : 0;

        articleKey = `${articleKey}-${organizerArticleId}`;
    }

    return articleKey;
};

class OrganizerArticleBucket extends Component {
    static propTypes = {
        trackGAEvent: PropTypes.func.isRequired,
        trackScrollEvent: PropTypes.func.isRequired,
        trackLimitReached: PropTypes.func.isRequired,
        bucketConfig: BUCKET_CONFIG_PROPTYPE,
        bucketContent: ORGANIZER_ARTICLE_BUCKET_PROPTYPE,
        onFollowOrganizer: PropTypes.func,
        handleViewOrganizer: PropTypes.func,
        bucketKey: PropTypes.string,
        name: EBPropTypes.translation,
        isLoading: PropTypes.bool,
        isMobile: PropTypes.bool,
        shouldUseWaypoints: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = {
            visible: !props.shouldUseWaypoints,
            initialCarouselIndex: 0,
            currentIndex: 0,
        };
    }

    _handleWaypointEnter = () => {
        this.setState({ visible: true });
    };

    _handleSwipe = ({ currentIndex }) => {
        const {
            bucketContent: { organizerArticles },
            bucketKey,
        } = this.props;
        const articleKey = getOrganizerArticleKey({
            bucketKey,
            organizerArticles,
            index: currentIndex,
        });

        this.setState({
            currentIndex,
        });

        storeLastVisitedCard({
            bucketKey,
            lastVisitedCardKey: articleKey,
            lastVisitedCardIndex: currentIndex,
        });
    };

    _handleSwipeLeft = ({ currentIndex }) => {
        const {
            trackScrollEvent,
            bucketContent: { organizerArticles },
        } = this.props;

        this._handleSwipe({ currentIndex });
        trackScrollEvent({
            index: currentIndex,
            action: GA_PREVIOUS_SLIDE_ACTION,
            organizerId: organizerArticles[currentIndex].id,
        });
    };

    _handleSwipeRight = ({ currentIndex }) => {
        const {
            trackScrollEvent,
            trackLimitReached,
            bucketContent: { organizerArticles },
        } = this.props;

        this._handleSwipe({ currentIndex });
        trackScrollEvent({
            index: currentIndex,
            action: GA_NEXT_SLIDE_ACTION,
            organizerId: organizerArticles[currentIndex].id,
        });

        if (currentIndex === organizerArticles.length - 1) {
            trackLimitReached();
        }
    };

    render() {
        const {
            bucketContent: {
                // eslint-disable-next-line no-shadow
                key,
                name: bucketContentName,
                description,
                organizerArticles,
            },
            onFollowOrganizer,
            handleViewOrganizer,
            trackGAEvent,
            bucketKey,
            name: bucketName,
            isLoading,
        } = this.props;
        const { visible, initialCarouselIndex, currentIndex } = this.state;
        const name = bucketName || bucketContentName;

        const bucketClassNamesDesktop = classNames(
            'feed-events-bucket',
            'feed-events-bucket--animated',
            {
                animate: visible,
            },
            'feed-five-to-follow-bucket',
        );

        let component = (
            <div className={bucketClassNamesDesktop} key={bucketKey}>
                <LoadingCards
                    type={ORGANIZER_ARTICLE_TYPE}
                    style="grid"
                    cardCount={1}
                />
            </div>
        );

        if (!isLoading) {
            let organizerArticlesCards = [];

            if (organizerArticles && organizerArticles.length) {
                // Using 'index + 1' for label on GA for start on 1
                organizerArticlesCards = organizerArticles.map(
                    (organizerArticle, index) => {
                        const component = (
                            <OrganizerArticleCard
                                key={`${key}|${organizerArticle.id}`}
                                organizerArticle={organizerArticle}
                                handleFollowOrganizer={onFollowOrganizer}
                                handleViewOrganizer={handleViewOrganizer}
                                trackGAEvent={trackGAEvent}
                                type="list"
                                label={`${bucketKey}|${
                                    organizerArticle.id
                                }|${index + 1}`}
                                isVisible={index === currentIndex}
                            />
                        );

                        return (
                            <div
                                key={`${key}|${organizerArticle.id}`}
                                className="eds-l-pad-hor-3 eds-l-sw-pad-hor-0"
                            >
                                {component}
                            </div>
                        );
                    },
                );

                component = (
                    <div className={bucketClassNamesDesktop} key={bucketKey}>
                        <div className="feed-five-to-follow-bucket__carousel-container">
                            <Carousel
                                title={name}
                                subtitle={description}
                                alwaysShowSideNavigation={true}
                                hasTopControls={true}
                                isNotContinuous={true}
                                usesNewStyle={true}
                                initialDisplayIndex={initialCarouselIndex}
                                onSwipeLeft={this._handleSwipeLeft}
                                onSwipeRight={this._handleSwipeRight}
                                transitionDuration={TRANSITION_DURATION}
                            >
                                {organizerArticlesCards}
                            </Carousel>
                        </div>
                    </div>
                );
            } else {
                component = null;
            }
        }

        return (
            <Waypoint onEnter={this._handleWaypointEnter} topOffset="-1000px">
                {component}
            </Waypoint>
        );
    }
}

export default OrganizerArticleBucket;
